import gql from "graphql-tag";

export const CREATE_WORKFLOW_WEBHOOK = gql`
  mutation addWorkflowWebhook($data: WebhookDataInput) {
    addWorkflowWebhook(data: $data) {
      id
    }
  }
`;

export const SEND_PERSONALIZED_QUOTE = gql`
  mutation sendPersonalizedQuote($notification: EngageNotificationInput!) {
    sendPersonalizedQuote(notification: $notification)
  }
`;

export const SEND_COMPLETE_SUBSCRIPTION = gql`
  mutation sendCompleteSubscription($notification: EngageNotificationInput!) {
    sendCompleteSubscription(notification: $notification)
  }
`;

export const SEND_FINALIZE_SUBSCRIPTION = gql`
  mutation sendFinalizeSubscription($notification: EngageNotificationInput!) {
    sendFinalizeSubscription(notification: $notification)
  }
`;


const workflows = { CREATE_WORKFLOW_WEBHOOK, SEND_PERSONALIZED_QUOTE };

export default workflows;
